import { EvSalesValues, EvSalesResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateEvSales(values: EvSalesValues, t?: ToolsTranslations['evSales']): EvSalesResult {
  const { marketCap, totalDebt, cash, sales } = values;

  if (marketCap < 0 || totalDebt < 0 || cash < 0 || sales <= 0) {
    return { ratio: null, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }

  const enterpriseValue = marketCap + totalDebt - cash;
  const ratio = Math.round((enterpriseValue / sales) * 100) / 100;

  if (!isFinite(ratio)) {
    return { ratio: null, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }

  return { ratio, enterpriseValue, isValid: true };
}


